import { ConstantsParser } from '../../../ConstantsParser'
import { StylesParser } from '../../../StylesParser'
export class Primary {
  constructor() {
   this.name = 'Primary'
   this.content = {
      text: 'Primary'
    }
   this.view = this.viewHtml()
  }

  viewHtml() {
    let classes = (new ConstantsParser(this.classes())).parse().join(' ')
    let styles = (new StylesParser(this.styles())).parse()
    styles = Object.keys(styles).map(variationStyle => `${variationStyle}:${styles[variationStyle]}`).join(';')
    return `<div
      class="${classes}"
      style="${styles}"
    >Primary</div>`
  }

  classes() {
    return [
      {property: 'FontSize', value: 'FONT_SIZE_XL'},
      {property: 'FontWeight', value: 'BOLD'},
    ]
  }

  styles() {
    return [
      {property:'TextColor', styleProperty: 'color', value: 'rgba(138.24,115.2,115.2, 1)'},
    ]
  }

  buildData() {
    return {
      name: this.name,
      view: this.view,
    }
  }

  editorProperties() {
    return {
      content: this.content,
      styles: {
        desktop: this.styles(),
        tablet: this.styles(),
        phone: this.styles(),
      },
      classes: {
        desktop: this.classes(),
        tablet: this.classes(),
        phone: this.classes(),
      },
    }
  }
}